import styled from "styled-components";

export const CalendarGrid = styled.div`
 display: grid;
 /* grid-template-columns: 1fr auto; */
 grid-template-columns: repeat(auto-fit, minmax(34.5rem, 1fr));
 column-gap: 2rem;
 row-gap: 2rem;
`